import type { useDemandePROAActions } from './useDemandePROAActions'

export const PROA_INJECT = Symbol('demande-inject')
export type DemandeProAActions = ReturnType<typeof useDemandePROAActions>
